import { toast } from 'react-toastify';

export const logout = (showToast = true) => {
    localStorage.setItem('not_login', true)
    localStorage.removeItem('userId')
    localStorage.removeItem('permissions')
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
    window.location.replace('/?#/login');

    if (showToast) {
        toast.error('⚠️Your session has ended, please reconnect.', {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: true,
            pauseOnHover: true,
            draggable: false,
        })
    }
}